<template>
    <div class="animated revealUp">
      <div class="white-wrapper">
        <div class="section-title">
          {{ $t("Movie Wise collection Report") }}
        </div>
        <small><em>{{ $t("* As Per show Date") }}</em></small>
        <div class="mt-3 mb-2">
          <div class="row">
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="dropdown-curve-container">
                <label
                  :class="
                    dropDown.cinemas && dropDown.cinemas.length > 0
                      ? 'shift-up'
                      : ''
                  "
                  >{{ $tc("cinema", 1) }}</label
                >
                <multiselect
                  :disabled="isRoleID"
                  :options="dropDown.cinemas"
                  v-model="dropDown.selectedCinema"
                  :searchable="true"
                  label="cine_name"
                  track-by="cine_id"
                  placeholder="Cinema"
                  @input="onSelectCinema($event)"
                  :allowEmpty="false"
                  :showLabels="false"
                ></multiselect>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="fromDate">
                      ✖
                    </button> -->
                  <Datepicker
                    :monday-first="true"
                    type="date"
                    ref="programaticOpen"
                    v-model="fromDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="fromDate ? 'active' : ''">
                    <!-- {{ $t("show") }} -->
                    {{ $t("fromdate") }}
                  </label>
                </div>
              </div>
            </div>
            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
              <div class="input-material">
                <div class="add-datepicker">
                  <!-- <button class="btn-clearDate" v-if="toDate">
                      ✖
                    </button> -->
                  <Datepicker
                    :monday-first="true"
                    ref="programaticOpen"
                    v-model="toDate"
                    v-validate="'required'"
                  ></Datepicker>
                  <label :class="toDate ? 'active' : ''">
                    <!-- {{ $t("show") }}  -->
                    {{ $t("todate") }}</label
                  >
                </div>
              </div>
            </div>

            <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label :class="selectedMovieName.length ? 'shift-up' : ''">{{
                $t("Movie Name")
              }}</label>
              <multiselect v-model="selectedMovieName" :options="allMovieNames" track-by="movie_name"
                label="movie_name" :disabled="isRoleID" :searchable="true" placeholder="" :multiple="true">
              </multiselect>
            </div>
          </div>
  
            <div class="col-lg-6 col-xl-2 align-self-center mb-3">
              <button
                class="btn-blue-lg w-100"
                @click.prevent="getMovieWiseData('N', 'N')"
              >
                {{ $t("fetch") }}
              
              </button>
            </div>
  
            <div
              v-if="movieWiseData.length > 0"
              class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
            >
              <div class="mx-1">{{ $t("download") }} as:</div>
              <!-- s -->
  
              <a
                target="_blank"
                @click="getMovieWiseData('Y', 'N')"
                title="Download as Excel"
                download
                style="cursor: pointer;"
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/excel.svg"
                  height="25"
                  width="25"
                />
              </a>
              <a
                target="_blank"
                @click="getMovieWiseData('N', 'Y')"
                title="Download as PDF"
                download
                style="cursor: pointer;"
              >
                <img
                  class="mx-1"
                  src="@/assets/img/icons/pdf.svg"
                  height="25"
                  width="25"
                />
              </a>
            </div>
          </div>
        </div>
  
        <div
          style="overflow-x:scroll;width: auto !important"
          ref="exportable_table"
        >
        <table class="swc-report-table" border="1">
            <thead >
              <tr style="background-color: rgb(200,200,200)">
                <th>Show Date</th>
                <th>Movie Name</th>
                <th>Show Time</th>
                <th>Screen</th>
                <th>Admits</th>
              </tr>
            </thead>
            <tbody v-if="movieWiseData.length === 0">
              <tr>
                <td colspan="11">
                  <div class="h6 my-3 text-center">{{ $t("NoRecords") }}</div>
                </td>
              </tr>
            </tbody>
            <!-- <template v-if="movieWiseData.length > 0">
              <tbody
                v-for="(
                  GetScreenCollectionReportList,
                  indexGetScreenCollectionReportList
                ) in movieWiseData"
                :key="indexGetScreenCollectionReportList"
              >
                <tr
                  v-for="(
                    Screens, ScreensIndex
                  ) in GetScreenCollectionReportList.data"
                  :key="ScreensIndex"
                >
                  <td  class="text-right">{{ Screens.t_show_date }}</td>
                  <td class="text-left">{{ Screens.movie_name }}</td>
                  <td class="text-right">{{ Screens.t_show_time }}</td>
                  <td class="text-left">{{ Screens.screen_name }}</td>
                  <td class="text-nowrap text-right" >{{ Screens.SoldNo }}</td>
                </tr>
                <tr style="background-color: rgb(232,232,232)">
                  <td colspan="4" class="py-1 text-right">
                    <strong
                    style="color: #222;"
                      >{{ $t("total") }}
                      {{
                        GetScreenCollectionReportList.data.length > 0
                          ? `For ${GetScreenCollectionReportList.data[0].movie_name}`
                          : ""
                      }}
                      </strong
                    >
                  </td>
                  <td class="py-1" style="text-align: right">
                    {{ GetScreenCollectionReportList.data.reduce((acc, { SoldNo }) => acc + (SoldNo || 0), 0) }}
                  </td>
                </tr>
              </tbody>
              <tbody>
                <tr style="background-color: rgb(222,222,222)">
                  <td colspan="4" class="py-1 text-left">
                    <strong>Grand Total</strong>
                  </td>
                  <td class="py-1" style="text-align: right">
                    <strong>{{grandTotal.soldNo}}</strong>
                  </td>
                </tr>
              </tbody>
            </template> -->

            <template v-if="movieWiseData.length > 0">
  <tbody
    v-for="(GetScreenCollectionReportList, indexGetScreenCollectionReportList) in movieWiseData"
    :key="indexGetScreenCollectionReportList"
  >
    <tr
      v-for="(Screens, ScreensIndex) in GetScreenCollectionReportList.data"
      :key="ScreensIndex"
    >
      <!-- Use rowspan for the date and movie name, but only for the first row -->
      <td 
        v-if="ScreensIndex === 0" 
        class="text-right" 
        :rowspan="GetScreenCollectionReportList.data.length"
      >
        {{ Screens.t_show_date }}
      </td>
      <td 
        v-if="ScreensIndex === 0" 
        class="text-left" 
        :rowspan="GetScreenCollectionReportList.data.length"
      >
        {{ Screens.movie_name }}
      </td>

      <td class="text-right">{{ Screens.t_show_time }}</td>
      <td class="text-left">{{ Screens.screen_name }}</td>
      <td class="text-nowrap text-right">{{ Screens.SoldNo }}</td>
    </tr>

    <!-- Total for each movie -->
    <tr style="background-color: rgb(232,232,232)">
      <td colspan="4" class="py-1 text-right">
        <strong style="color: #222;">
          {{ $t("total") }}
          {{
            GetScreenCollectionReportList.data.length > 0
              ? `For ${GetScreenCollectionReportList.data[0].movie_name}`
              : ""
          }}
        </strong>
      </td>
      <td class="py-1" style="text-align: right">
        {{ GetScreenCollectionReportList.data.reduce((acc, { SoldNo }) => acc + (SoldNo || 0), 0) }}
      </td>
    </tr>
  </tbody>

  <!-- Grand total row -->
  <tbody>
    <tr style="background-color: rgb(222,222,222)">
      <td colspan="4" class="py-1 text-left">
        <strong>Grand Total</strong>
      </td>
      <td class="py-1" style="text-align: right">
        <strong>{{ grandTotal.soldNo }}</strong>
      </td>
    </tr>
  </tbody>
</template>


          </table>
        </div>
      </div>
    </div>
  </template>
  <script>
  import { BASEURL } from "@/config/index";
  import MasterService from "@/services/MasterService";
  import ReportsService from "@/services/NewReportService";
  import moment from "moment";
  import NoRecords from "@/components/Partials/NoRecords.vue";
  import CinemasService from "@/services/CinemasService";
  import xlsx from "json-as-xlsx";
  import VueHtml2pdf from "vue-html2pdf";
  import * as XLSX from "xlsx";
  
  export default {
    components: {
      NoRecords,
      VueHtml2pdf,
    },
    data() {
      return {
        BASEURL,
        isRoleID: false,
        submitted: false,
        dropDown: {
          cinemas: [],
          selectedCinema: null,
          selectedCinemaName: null,
          selectedCinemaId: "",
        },
        fromDate: new Date(),
        toDate: new Date(),
        movieWiseData: [],
  
        excelFilePath: "",
        grandTotal: {},
        selectedMovieName: [],
        allMovieNames: [],
      };
    },
    beforeMount() {
      let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
      this.getCinemaList()
    },
    watch: {
      excelFilePath(value) {
        this.excelFilePath = value;
      },
      fromDate() {
      this.getMovieWiseData("N", "N", "filter");
    },
    toDate() {
      this.getMovieWiseData("N", "N", "filter");
    },
    },
    mounted() {},
    methods: {
      moment,
      getCinemaList: function () {
        MasterService.GetCinemas()
          .then((response) => {
            const { data } = response;
            if (data.status && data.Records.length > 0) {
              this.dropDown.cinemas = data.Records;
              this.CinemasCopy = data.Records;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError);
      },
      onSelectCinema: function (event) {
        this.dropDown.selectedCinema = event;
        this.dropDown.selectedCinemaName = event.cine_name;
        this.dropDown.selectedCinemaId = event.cine_id;
      this.getMovieWiseData("N", "N", "filter");
        this.$store.dispatch("selectDropdownCinema", event);
      },
      getMovieWiseData(isExcel = "N", isPdf = "N",type = "") {
        this.movieWiseData = [];
        if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
        if (!this.fromDate) {
          return this.$toasted.show("Select From Date");
        }
        let loader = this.$loading.show();
        let payload = {
          cinema_id: this.dropDown.selectedCinemaId,
          cinema_name: this.dropDown.selectedCinemaName || "",
          cinema_address: this.dropDown.selectedCinema.cine_address || "",
          fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
          toDate: moment(this.toDate).format("YYYY-MM-DD"),
          isExcel,
          isPdf,
        };
        if (type == "filter") {
        payload["type"] = "filter";
      }

      if (this.selectedMovieName.length) {
        payload["selectedMovieName"] = this.selectedMovieName.map(
          (offerObj) => {
            return offerObj.movie_name;
          }
        );
      }
        ReportsService.GetMovieWiseCollectionReport(payload)
          .then((response) => {
            const { data } = response;
          if (!data.status) return this.$toasted.show(data.message);

            if (type == "filter") {
            this.allMovieNames = [...data.movieNamesData];
          } 
            else{
              this.movieWiseData = [...data.Records];
              this.grandTotal = data.grandTotal;
              if (isExcel == "Y" && data.excelPath) {
                window.open(data.excelPath, "_blank");
              }
              if (isPdf == "Y" && data.pdfPath) {
                window.open(data.pdfPath, "_blank");
              }
              this.$toasted.show(data.message);
            }
          
            loader.hide();
          })
          .catch(this._CatchError)
          .finally(() => {
            setTimeout(() => {
              loader.hide();
            }, 100);
          });
      },
    },
  };
  </script>
  
  <style>
  .concession-analysis-table {
    width: 100%;
    border: 1px solid #787878;
  }
  
  .concession-analysis-table thead {
    text-align: center;
    background-color: #dddedf;
  }
  
  .concession-analysis-table thead th {
    
    border: 1px solid #000;
  }
  
  .concession-analysis-table tbody {
    border-bottom: 1px solid #000;
  }
  
  .concession-analysis-table tbody td {
   
    border-left: 1px solid #787878;
    border-right: 1px solid #787878;
  }
  
  .concession-analysis-table tbody td p {
    font-weight: bold;
    margin-bottom: 0;
  }
 
  
  .swc-report-table {
    table-layout: auto !important;
    overflow-x: scroll !important;
    border: 1px solid gray;
  }
  .swc-report-table td {
    white-space: nowrap;
  }
  .swc-report-table th {
    white-space: nowrap !important;
    border: 1px solid gray !important;
  }
  .swc_table_header th {
    border: 1px solid gray !important;
  }
  .no_border {
    border: 0px !important;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/movieWiseCollectionReport.vue